"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Skeleton = _interopRequireDefault(require("../Skeleton"));
var _Html = _interopRequireDefault(require("../Html"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const CustomText = props => {
  if (props.error) {
    return null;
  }
  if (props.loading) {
    const lines = props.lines ? props.lines : 1;
    const skeletonRows = [];
    for (var i = 0; i < lines; i++) {
      skeletonRows.push((0, _jsxRuntime.jsx)(_Skeleton.default, {
        "aria-hidden": "true"
      }, i));
    }
    return (0, _jsxRuntime.jsx)(_styles.Wrapper, {
      css: () => props.centerloader && _styles.center,
      "aria-busy": "true",
      children: skeletonRows
    });
  }
  return (0, _jsxRuntime.jsx)(_Html.default, {
    text: props.text,
    secondary: props.secondary,
    dark: props.dark,
    size: props.size,
    whiteSpace: props.whiteSpace
  });
};
var _default = exports.default = CustomText;